import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScLicenses = styled.div`
  padding: 16px 10px;
  margin-top: 64px;
  border-top: 1px solid ${({ theme }) => theme.grayColor6};
  border-bottom: 1px solid ${({ theme }) => theme.grayColor6};

  .licenses {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 24px;

    @media (${device.mobile}) {
      justify-content: space-evenly;
      gap: 32px;
    }

    & > div {
      transition: transform 0.2s;
      will-change: transform;

      a {
        display: block;
      }

      img {
        height: 44px;
        max-width: 150px;
        width: auto;
        display: block;
        object-fit: contain;
      }

      @media (hover: hover) {
        &:hover {
          transform: scale(1.1);
        }
      }
    }

    /* plain images: no hover affordance */
    &.no-links > div:hover {
      transform: none;
    }
  }
`;
